module.exports = __webpack_public_path__ + "img/logo.c11da863.png";